import { FC, useEffect, useMemo, useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Divider,
  Heading,
  SimpleGrid,
  Input,
  VStack,
  Image,
  Center,
  CircularProgress,
  Text,
  Container,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { Field, Form } from "react-final-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  CustomInput,
  DownloadFile,
  CustomCheckbox,
  CustomSelect,
  CustomMultiSelect,
} from "../../customComponents/components";
import { PageHead } from "../../home/components/PageHead";
import { CardsBlock } from "../../editUser/components/CardsBlock";
import {
  DonwloadComponent,
  DonwloadComponentNew,
} from "../../customComponents/components/CustomInput/CustomInput";
import moment from "moment";
import { API_URL } from "../../httpClient/constants";
import { useVehicleList } from "../../vehicle/hooks";
import { useArticleData, useArticleSet } from "../hooks";
import { useArticleCategoryList } from "../../articleCategory/hooks";

export const ArticleSetScreen = () => {
  const { article_id } = useParams();
  const toast = useToast();
  const { vehiclesList } = useVehicleList();
  const { ArticleCategoryList } = useArticleCategoryList();
  const { articleSetReq, articleSetLoading } = useArticleSet();
  const { articleData, articleDataLoading, getArticleData } =
    useArticleData(article_id);

  const onSubmit = async (values: any) => {
    console.log("onSubmit", values);
    const vIds = values?.vehicle_id?.map((v) => v.value);
    const res = await articleSetReq({ ...values, vehicle_id: vIds });
    if (res?.success) {
      toast({
        title: "статья создана",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      getArticleData(article_id);
    } else {
      toast({
        title: "возникла ошибка",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const vIdsSaved = useMemo(() => {
    //@ts-ignore
    if (articleData?.vehicle_id) {
      //@ts-ignore
      const vIdParsed = articleData?.vehicle_id?.split(",");
      console.log("vIdParsed", vIdParsed);
      console.log("vehiclesList", vehiclesList);
      return vehiclesList
        ?.filter((v) => vIdParsed.includes(v.id.toString()))
        ?.map((v) => {
          return {
            value: v.id,
            label: v.title,
          };
        });
    }
    return [];
  }, [articleData, vehiclesList]);

  if (articleSetLoading || articleDataLoading) {
    return (
      <Container height="calc(100vh - 240px)">
        <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
      </Container>
    );
  }
  console.log("vIdsSaved", vIdsSaved);
  return (
    <>
      <Form
        mutators={{
          setValue: ([field, value], state, { changeValue }) => {
            changeValue(state, field, () => value);
          },
        }}
        onSubmit={onSubmit}
        // validate={() => true}
        initialValues={{ ...articleData, vehicle_id: vIdsSaved }}
        render={({ form, handleSubmit, values }) => {
          return (
            <Box boxShadow="lg" p="6" rounded="md" bg="white">
              <Flex justify="space-between">
                <Breadcrumb
                  spacing="8px"
                  separator={<ChevronRightIcon color="gray.500" />}
                >
                  <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to="/article">
                      Статьи
                    </BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink href="#">
                      {article_id ? article_id : "Новая статья"}
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Flex>
              <Divider marginTop={"20px"} marginBottom={"20px"} />
              <Box width="100%">
                <Heading size={"md"}>
                  {article_id ? "Редактировать статью" : "Создать статью"}
                </Heading>
                <Divider marginTop={"20px"} marginBottom={"20px"} />
                <Field
                  name="title"
                  placeholder={"Заголовок"}
                  label={"Заголовок"}
                  // pattern={pattern}
                  component={CustomInput}
                />
                <div style={{ height: 20 }} />
                <Field
                  name="link"
                  placeholder={"Ссылка на статью"}
                  label={"Ссылка на статью"}
                  // pattern={pattern}
                  component={CustomInput}
                />
                <div style={{ height: 20 }} />
                {/* <DonwloadComponent
                  label={'Превью изображение'}
                  name='image'
                  // srcPic={destructure(name, values)}
                  url={API_URL}
                  onClick={() => {
                    handleLink(name, values);
                  }}
                  disabled={isDisabled(name, values)}
                /> */}
                <DonwloadComponentNew
                  name={"image"}
                  intialPreview={values["image"]}
                  label={"Главное изображение"}
                  multiple={false}
                  fullwidth={false}
                />
                <div style={{ height: 20 }} />
                <Field
                  name="reading_time"
                  placeholder={"Время на прочтение"}
                  label={"Время на прочтение"}
                  // pattern={pattern}
                  component={CustomInput}
                />
                <div style={{ height: 20 }} />
                <Field
                  name="vehicle_id"
                  placeholder={"Автомобили для подборки"}
                  label={"Автомобили для подборки"}
                  // pattern={pattern}
                  options={vehiclesList?.map((v) => {
                    return {
                      value: v.id,
                      label: v.title,
                    };
                  })}
                  // multiple
                  component={CustomMultiSelect}
                />
                <div style={{ height: 20 }} />
                <Field
                  name="category_id"
                  placeholder={"Категория"}
                  label={"Категория"}
                  // pattern={pattern}
                  options={ArticleCategoryList?.map((v) => {
                    return {
                      value: v.id,
                      label: v.label,
                    };
                  })}
                  // multiple
                  component={CustomSelect}
                />
                <div style={{ height: 20 }} />
                <Button onClick={handleSubmit}>Сохранить</Button>
              </Box>
            </Box>
          );
        }}
      />
    </>
  );
};
